import { createTheme } from '@mui/material/styles';

const fontFamily = '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export const light_theme = createTheme({
  palette: {
    mode: 'light',
    proposal_view_bg: '#f2f2f4',
    link: '#1976d2',
  },
  typography: {
    fontFamily: fontFamily,
    allVariants: {
      fontFamily: fontFamily,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: `${fontFamily} !important`,
        },
      },
    },
  },
});

export const dark_theme = createTheme({
  palette: {
    mode: 'dark',
    proposal_view_bg: '#f2f2f4',
    link: '#1976d2',
  },
  typography: {
    fontFamily: fontFamily,
    allVariants: {
      fontFamily: fontFamily,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: `${fontFamily} !important`,
        },
      },
    },
  },
});
